// localStorage-backed feed UI preferences. Small enough to live in
// one file; grows organically as we add more per-user feed knobs.

import { LS_TOPICS_EXPANDED } from './constants.js'

export function loadTopicsExpanded() {
  try {
    return localStorage.getItem(LS_TOPICS_EXPANDED) === '1'
  } catch {
    return false
  }
}

export function saveTopicsExpanded(value) {
  try {
    localStorage.setItem(LS_TOPICS_EXPANDED, value ? '1' : '0')
  } catch { /* noop */ }
}
